import { createVaultModule } from '@izimi/modules';
import { vaultApi } from 'core/di';

export const vaultModule = createVaultModule({ vaultApi });
